/**
 * Logo Component - Two-line text logo
 * 
 * Props:
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - showText: boolean - whether to show text (default: true)
 * - className: string - additional CSS classes
 */

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  // Size configurations
  const sizeConfig = {
    sm: { fontSize: '11px', lineHeight: '1.2' },
    md: { fontSize: 'clamp(13px, 3vw, 18px)', lineHeight: '1.2' },
    lg: { fontSize: '28px', lineHeight: '1.2' }
  };

  const config = sizeConfig[size] || sizeConfig.md;

  return (
    <a 
      href="/"
      className={className}
      style={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: config.fontSize,
        lineHeight: config.lineHeight,
        color: 'var(--charcoal, #2C3E50)',
        letterSpacing: '0.5px',
        textDecoration: 'none',
        whiteSpace: 'normal',
        overflow: 'hidden',
        maxWidth: '100%'
      }}
    >
      <div style={{ fontSize: '0.9em', whiteSpace: 'nowrap' }}>Christian Family</div>
      <div style={{ fontWeight: '800', letterSpacing: 'clamp(0.5px, 0.35vw, 1.65px)', fontSize: '1.26em', whiteSpace: 'nowrap' }}>RECOVERY</div>
    </a>
  );
};

export default Logo;
